import { getTextFromHtml } from '@/commonFunctions/utils'
import { DESCRIPTION_MAX_LENGTH, DESCRIPTION_MIN_LENGTH, IMAGE_MAX_SIZE, TITLE_MAX_LENGTH } from '@/constants/Common'
import {
  EVENT_ANNOUCEMENT_DESCRIPTION_MAX,
  EVENT_ANNOUCEMENT_DESCRIPTION_MIN,
  EVENT_ANNOUNCEMENT_TITLE_MAX,
  EVENT_DESCRIPTION_REQUIRED,
  EVENT_NAME_REQUIRED,
  IMAGE_SIZE,
  IMAGE_TYPE,
  REGISTRATION_URL_REQUIRED,
} from '@/constants/MessageConstants'
import * as Yup from 'yup'
import { LocationValidationSchema } from './CommonValidationSchema'

const CreateEventValidationSchema = Yup.object().shape({
  logo: Yup.mixed()
    .notRequired()
    .test('fileSize', IMAGE_SIZE, (value: any) => {
      return value ? value.size <= IMAGE_MAX_SIZE : true
    })
    .test('fileType', IMAGE_TYPE, (value: any) => {
      return value ? value.type === 'image/png' || value.type === 'image/jpeg' : true
    }),
  leagueName: Yup.string().required(EVENT_NAME_REQUIRED).max(TITLE_MAX_LENGTH, EVENT_ANNOUNCEMENT_TITLE_MAX),
  registrationUrl: Yup.string()
    .required(REGISTRATION_URL_REQUIRED)
    .test(
      'no-utrsports-url',
      'The provided URL can not be used for registration at this time',
      (value) => !value || !value.includes('app.utrsports.net')
    ),
  address: LocationValidationSchema,
  startDate: Yup.string().required('Start date is required'),
  endDate: Yup.string().required('End date is required'),
  longDescription: Yup.string()
    .required(EVENT_DESCRIPTION_REQUIRED)
    .test(
      'minlength',
      EVENT_ANNOUCEMENT_DESCRIPTION_MIN,
      (desc) => getTextFromHtml(desc).length >= DESCRIPTION_MIN_LENGTH
    )
    .test(
      'maxlength',
      EVENT_ANNOUCEMENT_DESCRIPTION_MAX,
      (desc) => getTextFromHtml(desc).length <= DESCRIPTION_MAX_LENGTH
    ),
})

export default CreateEventValidationSchema
